import { SpTooltip } from 'components/shared/Tooltip/Tooltip';
import { UnderlyingTag } from 'components/underlying-tag';
import { Underlying } from 'models/underlying';
import { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  className?: string;
  isDisabled: boolean;
  isHighlighted: boolean;
  value: Underlying | undefined;
  label: string;
  canHighlight?: boolean;
  onTagHighlightToggled?: (labelToToggle: string) => void;
  onTagRemoved: (labelToRemove: string) => void;
}

export function TagBadge({
  className,
  isDisabled,
  isHighlighted,
  value,
  label,
  canHighlight,
  onTagHighlightToggled,
  onTagRemoved,
}: Props): ReactElement {
  return (
    <SpTooltip
      disabled={!value?.hasMissingCodes}
      position="top"
      color="secondary"
      contents={<FormattedMessage id="form.Underlyings.missingCodes" />}
    >
      <UnderlyingTag
        dataE2e="underlying-badge"
        className={className}
        label={label}
        value={value}
        size="lg"
        isHighlighted={isHighlighted}
        onRemove={() => onTagRemoved(label)}
        isReadOnly={isDisabled}
        onToggleHighlight={canHighlight ? () => onTagHighlightToggled?.(label) : undefined}
      />
    </SpTooltip>
  );
}
